function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.70588 27.2941H17.0588C18.001 27.2941 18.7647 26.5304 18.7647 25.5882V1.70588C18.7647 0.763749 18.001 0 17.0588 0H1.70588C0.763749 0 0 0.763749 0 1.70588V25.5882C0 26.5304 0.763749 27.2941 1.70588 27.2941ZM1.70588 25.5882V1.70588H17.0588V25.5882H1.70588Z",
  fill: "#F8D635"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 0.852905,
  y: 22.1763,
  width: 17.0588,
  height: 1.70588,
  fill: "#F8D635"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 0.852905,
  y: 3.41162,
  width: 17.0588,
  height: 1.70588,
  fill: "#F8D635"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M14.4846 17.0727C14.2582 17.0731 14.041 16.9835 13.8807 16.8236L13.1745 16.1174C12.3715 15.319 11.9217 14.2321 11.9258 13.0997V11.1021C11.9258 9.68891 10.7802 8.54328 9.36697 8.54328C7.95377 8.54328 6.80815 9.68891 6.80815 11.1021V13.0997C6.81176 14.2315 6.36206 15.3177 5.55944 16.1157L4.8532 16.8219C4.51853 17.1452 3.98654 17.1405 3.65754 16.8115C3.32853 16.4825 3.3239 15.9505 3.64715 15.6159L4.35338 14.9096C4.83446 14.4304 5.10408 13.7788 5.10226 13.0997V11.1021C5.10226 8.74678 7.01164 6.8374 9.36697 6.8374C11.7223 6.8374 13.6317 8.74678 13.6317 11.1021V13.0997C13.6299 13.7788 13.8995 14.4304 14.3806 14.9096L15.0868 15.6159C15.3312 15.8596 15.4045 16.2266 15.2727 16.5456C15.1408 16.8646 14.8298 17.0726 14.4846 17.0727Z",
  fill: "#F8D635"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M14.4846 17.0726H4.2493C3.77824 17.0726 3.39636 16.6907 3.39636 16.2196C3.39636 15.7486 3.77824 15.3667 4.2493 15.3667H14.4846C14.9557 15.3667 15.3375 15.7486 15.3375 16.2196C15.3375 16.6907 14.9557 17.0726 14.4846 17.0726Z",
  fill: "#F8D635"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M9.36705 18.7785C7.95385 18.7785 6.80823 17.6328 6.80823 16.2196C6.80823 15.7486 7.1901 15.3667 7.66117 15.3667C8.13224 15.3667 8.51411 15.7486 8.51411 16.2196C8.51411 16.6907 8.89598 17.0726 9.36705 17.0726C9.83812 17.0726 10.22 16.6907 10.22 16.2196C10.22 15.7486 10.6019 15.3667 11.0729 15.3667C11.544 15.3667 11.9259 15.7486 11.9259 16.2196C11.9259 17.6328 10.7803 18.7785 9.36705 18.7785Z",
  fill: "#F8D635"
});

var SvgBenefits2 = function SvgBenefits2(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 28,
    viewBox: "0 0 19 28",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBenefits2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/benefits2.a81d263e.svg";
export { ForwardRef as ReactComponent };